export default __webpack_public_path__ + "static/media/bmm-hydrant.4d1fffa4.jpg";